// app/styles/colors.ts
import type { MantineColorsTuple } from "@mantine/core";

export const brand: MantineColorsTuple = [
  "#FFF3E6", // 0
  "#FFE1C7", // 1
  "#FFC99A", // 2
  "#FFAF6B", // 3
  "#FF9A45", // 4
  "#F28622", // 5
  "#E67E22", // 6  primary
  "#C96C1C", // 7
  "#A05516", // 8
  "#733B0F", // 9
];

export const secondary: MantineColorsTuple = [
  "#F5F2FF", // 0
  "#EAE5FF", // 1
  "#D7CCFF", // 2
  "#BEADFF", // 3
  "#A78FFF", // 4
  "#8C6BFF", // 5
  "#6C5CE7", // 6
  "#574AC1", // 7
  "#433A99", // 8
  "#2E276E", // 9
];
